export const DisqualifyOptions = {
  LESS_DEVELOPED: 'LESS_DEVELOPED',
  UNDER_18: 'UNDER_18',
  INVALID_CONTACT: 'INVALID_CONTACT',
  NOT_SERIOUS: 'NOT_SERIOUS',
  OTHER: 'OTHER',
};
